"use strict";

var _themeSections = require("@shopify/theme-sections");

var _freeReads = _interopRequireDefault(require("../components/free-reads"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Template: Index
 * -----------------------------------------------------------------------------
 * Scripts to execute on the index page.
 *
 */


document.addEventListener('DOMContentLoaded', function () {
  (0, _freeReads["default"])().init();
  (0, _themeSections.load)('*');
});